import { Injectable, inject } from "@angular/core";
import { ICompanyItemsResponse, getCurrencyContract } from "./company-items.interface";
import { Observable, ReplaySubject, first, from, of, switchMap, tap } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { eContracts } from "../contract/contract.config";
import { eCurrencies } from "app/common/ui/info-icon/info-icon.interface";
import { LootboxesContractService } from "../contract/contracts-services/lootboxes.service";
import { NFTv2Service } from "../contract/contracts-services/nft.service";
import { NFTItemService } from "../contract/contracts-services/nft-item.service";
import { ContractsService } from "../contract/contracts.service";
import { BigNumber } from "ethers";
import { Web3Service } from "../web3/web3.service";

@Injectable({
    providedIn: 'root'
})
export class CompanyItemsService {

    private _companyItems: ReplaySubject<ICompanyItemsResponse[]> = new ReplaySubject<ICompanyItemsResponse[]>(1);

    constructor(
        private http: HttpClient,
        private lootboxService: LootboxesContractService,
        private nftV2Service: NFTv2Service,
        private contractsService: ContractsService,
        private web3Service: Web3Service,
        private nftItemSevice: NFTItemService
    ) { }

    getAll(): Observable<ICompanyItemsResponse[]> {
        return this.http.get<ICompanyItemsResponse[]>(environment.apiBaseUrlV22 + 'nft-items/').pipe(
            tap((item: ICompanyItemsResponse[]) => {
                //to add USDT for battle league pass
                /*let battleLeaguePassDollarsAmount: number = item.filter(i => i.id == 'BATTLE_LEAGUE_PASS')[0].dollarPrice;
                item.filter(i => i.id == 'BATTLE_LEAGUE_PASS')[0].prices.push(
                    {
                        price: battleLeaguePassDollarsAmount.toString(),
                        currency: {
                            name: 'USDT',
                            symbol: eCurrencies.USDT,
                            address: '0x55d398326f99059fF775485246999027B3197955'
                        }
                    }
                );*/

                item.forEach(i => {
                    let priceInDollars = i.dollarPrice;
                    i.prices.push({
                        price: (Math.round(priceInDollars * 100) / 100).toString(),
                        currency: {
                            name: 'USD',
                            symbol: eCurrencies.CreditCard,
                            address: '0x0000000000000000000000000000000000000000'
                        }
                    });
                    if (typeof (i.dollarPrice) == 'string') i.dollarPrice = parseFloat(i.dollarPrice);
                })
                //remove all unused currency
                item.forEach(i => {
                    let index = i.prices.findIndex(p => !p.currency);
                    if (index != -1) i.prices.splice(index, 1);
                });
                item.forEach(i => {
                    //if (i.contract == eContracts.Lootbox) {
                    i.prices.forEach(p => {
                        if (p.currency.symbol == eCurrencies.BabyDoge) {
                            let index = i.prices.findIndex(p => p.currency.symbol == eCurrencies.BabyDoge);
                            i.prices.splice(index, 1);
                        } //p.price = (parseFloat(p.price) * 1000000000) + '';
                    })
                    //}
                });
                this._companyItems.next(item);
            })
        );
    }

    get companyItems$(): Observable<ICompanyItemsResponse[]> {
        return this._companyItems.asObservable();
    }

    buyItem(wallet: string, idOnchain: string, itemContract: eContracts, currency: eCurrencies, price?: number, amount: number = 1): Observable<any> {
        let serviceToBuy;
        switch (itemContract) {
            case eContracts.Lootbox:
                serviceToBuy = this.lootboxService /* inject(LootboxesContractService) */;
                break;
            case eContracts.NFTItems:
                serviceToBuy = this.nftItemSevice/* inject(NFTv2Service) */;
            default:
                break;
        }
        let currencyContract: eContracts = getCurrencyContract(currency);
        let contractAddress: string = this.contractsService.getContractAddress(itemContract);
        if (currency == eCurrencies.CANDIES) {
            return serviceToBuy.buyItem(wallet, idOnchain, amount, currency, price);
        } else {
            return this.allowance(wallet, contractAddress, this.contractsService.getContract(currencyContract)).pipe(switchMap(
                allowance => {
                    let hasAllowanceItems = BigNumber.from(allowance).gt(0);
                    if (hasAllowanceItems) {
                        // console.log('start Purchase');
                        console.log(serviceToBuy)
                        return serviceToBuy.buyItem(wallet, idOnchain, amount, currency, price);
                    } else {
                        return this.approve(wallet, contractAddress, this.contractsService.getContract(currencyContract)).pipe(first(), switchMap(value => {
                            console.log('value approve', value);
                            return serviceToBuy.buyItem(wallet, idOnchain, amount, currency, price);
                        }));
                    }
                }));
        }
    }

    allowance(ownerAddress: string, spenderAddress: string, contractOfCurrency: any): Observable<any> {
        return from(contractOfCurrency.methods.allowance(ownerAddress, spenderAddress).call());
    }

    approve(wallet: string, address: string, contractOfCurrency: any, amount: number = 999999999999): Observable<any> {
        let web3 = this.web3Service.getWeb3();
        return from(contractOfCurrency.methods.approve(address, web3.utils.toWei(amount.toString())).send({ ...this.contractsService.additionalParameters(), from: wallet }));
    }
}

